import { MEDIA_API_URL } from "../api";

/**
 * Safely constructs a media URL.
 * If the path is already an absolute URL (starts with http:// or https://), it returns the path as is.
 * Otherwise, it prepends MEDIA_API_URL and ensures no double slashes (except for the protocol).
 * 
 * @param {string} path - The relative or absolute path to the media file.
 * @returns {string|null} - The full URL or null if path is empty.
 */
export const getMediaUrl = (path) => {
    if (!path) return null;

    // Check if the path is already an absolute URL (more robust check)
    // Matches http://, https://, or even malformed https//
    if (/^https?[:/]/i.test(path)) {
        let finalPath = path;
        
        // Fix malformed https// (missing colon)
        if (finalPath.startsWith('https//') && !finalPath.startsWith('https://')) {
            finalPath = finalPath.replace('https//', 'https://');
        } else if (finalPath.startsWith('http//') && !finalPath.startsWith('http://')) {
            finalPath = finalPath.replace('http//', 'http://');
        }

        return finalPath;
    }

    // Ensure path doesn't have a leading slash if MEDIA_API_URL has a trailing one
    const baseUrl = MEDIA_API_URL.endsWith('/') ? MEDIA_API_URL.slice(0, -1) : MEDIA_API_URL;
    const cleanPath = path.startsWith('/') ? path : `/${path}`;

    return `${baseUrl}${cleanPath}`;
};
